import React from "react";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import ValidityHelper from "../../../../Helpers/ValidityHelper";
import selectHelper from "../../../../Helpers/selectHelper";
import ThirdPartyJobPaymentsService from "../../../../Services/ThirdParty/ThirdPartyJobPaymentsService";
import ThirdPartyJobPaymentsAdminItem from "../../../../Domain/ThirdParty/ThirdPartyJobPayments/ThirdPartyJobPaymentsAdminItem";

export default class EditTpAdvancePaymentWindowDescription extends React.Component {
  static titleForCreate = "New Advance Payment";
  static titleForEdit = "Edit Advance Payment";
  static itemType = ThirdPartyJobPaymentsAdminItem;
  static serviceFunction = (edited) => ThirdPartyJobPaymentsService.UpsertEvaluatorPayment(edited);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: "General",
      fields: [
        { fieldName: "EvaluatorCurrencyId", label: "Currency", type: InputTypesEnum.CurrencySelect, validityChecker: ValidityHelper.forRequiredSelectField },
        {
          fieldName: "Reimbursement",
          label: "Reimbursement",
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: "PaymentTypeText",
          label: "Payment Method",
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: EditTpAdvancePaymentWindowDescription.getPaymentMethods(),
        },
        { fieldName: "Comment", label: "Comment", type: InputTypesEnum.TextBox, validityChecker: ValidityHelper.AlwaysFlawless },
      ],
    },
  ];

  static getPaymentMethods() {
    return selectHelper.generateSelectValues(["Check", "International", "Tipalti"]);
  }
}
